import React from 'react';
import './ImpactSection.scss';
 
// Replace with your real, up-to-date figures — they weren't visible in the
// screenshot (looked cropped/not rendered), so these are placeholders.
const STATS = [
  { id: 'femmes', value: '12 500+', label: 'Femmes formées depuis le lancement' },
  { id: 'completion', value: '87%', label: 'Taux de complétion des formations' },
  { id: 'insertion', value: '68%', label: "Taux d'insertion professionnelle" },
  { id: 'regions', value: '12', label: 'Régions couvertes' },
];
 
const ImpactSection = () => {
  return (
    <div className="unfm-impact">
      <section className="impact">
        <div className="impact__container">
          <h2 className="impact__title">
            L&apos;impact d&apos;UNFM en quelques chiffres
          </h2>
 
          <div className="impact__grid">
            {STATS.map((stat) => (
              <div className="impact__stat" key={stat.id}>
                <span className="impact__stat-value">{stat.value}</span>
                <span className="impact__stat-dash" />
                <span className="impact__stat-label">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
 
export default ImpactSection;